import {
  PlusOutlined,
  SearchOutlined,
  FileExcelOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Input,
  Menu,
  message,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
} from 'antd';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

import { font } from '../../Common/font';
import dayjs from 'dayjs';
import { useEffect, useRef, useState, useCallback } from 'react';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Archiveicon } from '../../Images/Archiveicon.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnList } from '../../Images/ColumnList.svg';
import { ReactComponent as EditIcon } from '../../Images/EditIcon.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { ReactComponent as PrintIcon } from '../../Images/SimplePrintIcon.svg';
import { ReactComponent as PrintIcons } from '../../Images/PrintIcon.svg';
import { ReactComponent as ViewIcon } from '../../Images/ViewIcon.svg';
import { ReactComponent as Archive } from '../../Images/archive.svg';
import { deleteQuotation, fetchQuotationList } from '../../slices/quotation';
import logo from '../../Images/alux-logo.png';
import moment from 'moment';
import eventBus from '../../utils/eventBus';
import { fetchAndSetIpAddress } from '../../slices/ipSlice';
import { createActivityLog } from '../../slices/activity-log';

export default function QuotationList() {
  const { user: currentUser } = useSelector(state => state.auth);
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState(
    localStorage.getItem('quotationList') || '',
  );
  const [inputValue, setInputValue] = useState(
    localStorage.getItem('quotationList') || '',
  );
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [pagesize, setPageSize] = useState(20);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const {
    data = [],
    totalRecord,
    status,
  } = useSelector(state => state.quotation);
  const ipAddress = useSelector(state => state.ip.ipAddress);
  useEffect(() => {
    if (!ipAddress) {
      dispatch(fetchAndSetIpAddress());
    }
  }, [ipAddress, dispatch]);

  ;
  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
  };
  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };
  const debounceTimeout = useRef(null);

  const handleSearch = e => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('quotationList', value);
  };
  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy(null); // if applicable

    localStorage.removeItem('quotationList');
    dispatch(fetchQuotationList({ page: 1, pagesize }));
  };

  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = 'id';

    if (sortField === 'SrNo' && sortOrder === 'ascend') {
      sortingEnumKey = 'SrNo';
    }
    if (sortField === 'SrNo' && sortOrder === 'descend') {
      sortingEnumKey = '-SrNo';
    }
    if (sortField === 'quotation_date' && sortOrder === 'ascend') {
      sortingEnumKey = 'quotation_date';
    }
    if (sortField === 'quotation_date' && sortOrder === 'descend') {
      sortingEnumKey = '-quotation_date';
    }
    if (sortField === 'quotation_no' && sortOrder === 'ascend') {
      sortingEnumKey = 'quotation_no';
    }
    if (sortField === 'quotation_no' && sortOrder === 'descend') {
      sortingEnumKey = '-quotation_no';
    }
    if (sortField === 'customer' && sortOrder === 'ascend') {
      sortingEnumKey = 'customer';
    }
    if (sortField === 'customer' && sortOrder === 'descend') {
      sortingEnumKey = '-customer';
    }
    if (sortField === 'workorder_no' && sortOrder === 'ascend') {
      sortingEnumKey = 'workorder_no';
    }
    if (sortField === 'workorder_no' && sortOrder === 'descend') {
      sortingEnumKey = '-workorder_no';
    }
    if (sortField === 'converted_date' && sortOrder === 'ascend') {
      sortingEnumKey = 'converted_date';
    }
    if (sortField === 'converted_date' && sortOrder === 'descend') {
      sortingEnumKey = '-converted_date';
    }
    if (sortField === 'status' && sortOrder === 'ascend') {
      sortingEnumKey = 'status';
    }
    if (sortField === 'status' && sortOrder === 'descend') {
      sortingEnumKey = '-status';
    }

    return sortingEnumKey;
  };

  const fetchQuotation = useCallback(() => {
    dispatch(
      fetchQuotationList({
        page,
        pagesize,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
  }, [dispatch, page, pagesize, search, orderBy]);

  useEffect(() => {
    fetchQuotation();
  }, [fetchQuotation]);

  useEffect(() => {
    const handleReload = () => {
      fetchQuotation();
    };

    eventBus.on("financialYear:refresh", handleReload);

    return () => {
      eventBus.off("financialYear:refresh", handleReload);
    };
  }, [fetchQuotation]);

  const handlePageChange = newPage => {
    setPage(newPage);
    setOrderBy('');
  };

  const handleDelete = id => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }

    dispatch(deleteQuotation(id))
      .unwrap()
      .then(() => {
        message.success('Quatation Archive Successfully!');
        dispatch(
          fetchQuotationList({
            page,
            pagesize,
            ...(search && { search: search }),
            ...(orderBy && { ordering: orderBy }),
          }),
        );
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error); // Handle string error
        } else if (error instanceof Error) {
          message.error(error.message); // Handle Error object
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };
  const handleEdit = record => {
    navigate(`/edit-quotation/${record.id}`);
  };

  const loadImageAsBase64 = url => {
    return new Promise((resolve, reject) => {
      const cacheBustUrl = `${url}${url.includes('?') ? '&' : '?'}nocache=${new Date().getTime()}`;

      const img = new Image();
      img.crossOrigin = 'Anonymous';

      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/jpeg'));
      };

      img.onerror = () => reject(new Error('Failed to load image'));
      img.src = cacheBustUrl;
    });
  };
  const handlePrint = () => {
    /* PDF Download */
    const pdf = new jsPDF('p', 'pt', 'a4');
    pdf.addFileToVFS('WorkSans-normal.ttf', font);
    pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal');
    pdf.setFont('WorkSans');

    const pdfColumns = [
      { header: 'Sr No.', dataKey: 'SrNo', field: 'SrNo' },
      { header: 'Quotation Date', dataKey: 'quotation_date', field: 'quotation_date' },
      { header: 'Quotation No', dataKey: 'quotation_no', field: 'quotation_no' },
      { header: 'Customer', dataKey: 'customer', field: 'customer' },
      { header: 'WorkOrder No.', dataKey: 'workorder_no', field: 'workorder_no' },
      { header: 'Converted Date', dataKey: 'converted_date', field: 'converted_date' },
      { header: 'Status', dataKey: 'status', field: 'status' },
      { header: 'Created At', dataKey: 'created_at', field: 'created_at' },
      { header: 'Created By', dataKey: 'created_by__first_name', field: 'created_by__first_name' },
      { header: 'Updated At', dataKey: 'updated_at', field: 'updated_at' },
      { header: 'Updated By', dataKey: 'updated_by__first_name', field: 'updated_by__first_name' },
    ];

    const pdffilteredColumns = pdfColumns.filter(column =>
      checkedList.includes(column.dataKey),
    );

    const rows = data.map((item, index) => ({
      SrNo: index + 1,
      quotation_date: item?.quotation_date ? dayjs(item.quotation_date).format('DD-MM-YYYY') : 'N/A',
      quotation_no: item?.quotation_no || 'N/A',
      customer: item?.customer?.customer_name || 'N/A',
      workorder_no: item.workorder_no || 'Not Converted to Workorder',
      converted_date: item?.converted_date ? dayjs(item.converted_date).format('DD-MM-YYYY') : 'N/A',
      status: item.status || 'N/A',
      created_at: item.created_at ? moment(item.created_at).format('DD-MM-YYYY') : 'N/A',
      created_by__first_name: `${item.created_by__first_name} ${item.created_by__last_name}` || 'N/A',
      updated_at: item.updated_at ? moment(item.updated_at).format('DD-MM-YYYY') : 'N/A',
      updated_by__first_name: `${item.updated_by__first_name} ${item.updated_by__last_name}` || 'N/A',
    }));

    const currentDateTime = moment().format('DD/MM/YYYY hh:mm:ss A');
    const printText = `${currentDateTime}`;

    const pageWidth = pdf.internal.pageSize.width;
    const pageHeight = pdf.internal.pageSize.height;

    pdf.text('Quotation', pageWidth / 2, 40, { align: 'center' });

    // ✅ Add Logo ONLY on the first page
    const logoWidth = 60;

    pdf.autoTable({
      columns: pdffilteredColumns,
      body: rows,
      startY: 80,
      theme: 'grid',
      styles: {
        font: 'times',
        halign: 'center',
        overflow: 'linebreak',
        cellPadding: 3.5,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
      },
      headStyles: {
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        fillColor: false,
      },
      rowStyles: {
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      tableLineColor: [0, 0, 0],
      rowPageBreak: 'avoid',
      margin: { top: 80, left: 20, right: 20, bottom: 40 },
      didDrawPage: (data) => {
        const pageNumber = pdf.internal.getNumberOfPages();
        pdf.setFontSize(10);
        pdf.text(printText, 20, pageHeight - 20); // Left
        pdf.text(`Page ${pageNumber}`, pageWidth - 50, pageHeight - 20); // Right

        if (pageNumber === 1) {
          pdf.addImage(logo, 'PNG', pageWidth - 100, 10, 90, 30);
        }
      },
    });

    pdf.autoPrint();
    const pdfBlob = pdf.output('blob');

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0px';
    iframe.style.bottom = '0px';
    iframe.style.width = '1px';
    iframe.style.height = '1px';
    iframe.style.border = 'none';
    iframe.src = URL.createObjectURL(pdfBlob);

    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    dispatch(
      createActivityLog({
        action: 'PRINT',
        module_name: 'Quotation',
        ip_address: ipAddress,
        discription: 'Quotation print download successfully!',
      }),
    );
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: 100,
      render: (text, record, index) => {
        return (page - 1) * pagesize + index + 1;
      },
    },
    {
      title: 'Quotation Date',
      dataIndex: 'quotation_date',
      key: 'quotation_date',
      render: quotation_date => {
        return (
          <span>
            {quotation_date
              ? dayjs(quotation_date).format('DD-MM-YYYY')
              : 'N/A'}
          </span>
        );
      },
      sorter: true,
    },
    {
      title: 'Quotation No.',
      dataIndex: 'quotation_no',
      key: 'quotation_no',
      sorter: true,
      render: quotation_no => {
        return <span>{quotation_no ? quotation_no : 'N/A'}</span>;
      },
    },
    {
      title: 'Customer',
      key: 'customer',
      sorter: true,
      render: (_, record) => (
        <span>{record?.customer?.customer_name || 'N/A'}</span>
      ),
    },
    {
      title: 'WorkOrder No.',
      dataIndex: 'workorder_no',
      key: 'workorder_no',
      sorter: true,
      render: workorder_no => {
        return (
          <span>
            {workorder_no ? workorder_no : 'Not Converted to Workorder'}
          </span>
        );
      },
    },
    {
      title: 'Converted Date',
      dataIndex: 'converted_date',
      key: 'converted_date',
      sorter: true,
      render: converted_date => {
        return (
          <span>
            {converted_date
              ? dayjs(converted_date).format('DD-MM-YYYY')
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: status => {
        return <span>{status ? status : 'N/A'}</span>;
      },
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: record => {
        return (
          <span>
            {record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'}{' '}
          </span>
        );
      },
    },
    {
      title: 'Created By',
      dataIndex: 'created_by__first_name',
      key: 'created_by',
      render: (_, record) => {
        return (
          <span>
            {record.created_by__first_name || 'N/A'}{' '}
            {record.created_by__last_name || 'N/A'}
          </span>
        );
      },
    },

    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: record => {
        return (
          <span>
            {record && record.trim()
              ? dayjs(record).format('DD-MM-YYYY HH:mm')
              : 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Updated By',
      dataIndex: 'updated_by__first_name',
      key: 'updated_by',
      render: (_, record) => {
        return (
          <span>
            {record.updated_by__first_name || 'N/A'}{' '}
            {record.updated_by__last_name || 'N/A'}
          </span>
        );
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space>
          <>
            {currentUser.permissions.permissions.quotation.includes(
              'view_quotation',
            ) && (
                <Tooltip title="View">
                  <Link to={`/view-quotation-list/${record.id}`}>
                    <ViewIcon />
                  </Link>
                </Tooltip>
              )}
            {currentUser.permissions.permissions.quotation.includes(
              'print_quotation_pdf_copy',
            ) && (
                <Tooltip title="Print">
                  <Link
                    to={`/print-quotation/${record.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <PrintIcon />
                  </Link>
                </Tooltip>
              )}
          </>

          {currentUser.permissions.permissions.quotation.includes(
            'change_quotation',
          ) && (
              <Tooltip placement="top" title={'Edit'}>
                <span
                  onClick={() => handleEdit(record)}
                  style={{ cursor: 'pointer' }}
                >
                  <EditIcon />
                </span>
              </Tooltip>
            )}
          {currentUser.permissions.permissions.quotation.includes(
            'delete_quotation',
          ) && (
              <Tooltip title="Archive">
                <Popconfirm
                  title="Are you sure you want to archive this record?"
                  onConfirm={() => handleDelete(record.id)}
                  onCancel={() => message.info('Action cancelled')}
                  okText="Yes"
                  cancelText="No"
                >
                  <Link>
                    <Archive />
                  </Link>
                </Popconfirm>
              </Tooltip>
            )}
        </Space>
      ),
    },
  ];

  const [checkedList, setCheckedList] = useState([
    'SrNo',
    'quotation_date',
    'quotation_no',
    'customer',
    'workorder_no',
    'action',
    'converted_date',
    'status',
  ]);

  const handlePrintDownload = async record => {
    const doc = new jsPDF('p', 'pt', 'a4');
    doc.addFileToVFS('WorkSans-normal.ttf', font);
    doc.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal');
    doc.setFont('WorkSans');
    const pageHeight = doc.internal.pageSize.height;
    let y = 20;
    const imgUrl = logo; // Replace with your image
    const imgWidth = 181; // Adjust width as needed
    const imgHeight = 48; // Adjust height as needed
    const margin = 10;
    const imgX = doc.internal.pageSize.width / 2 + 110;
    const imgY = margin;

    doc.addImage(imgUrl, 'JPEG', imgX, imgY, imgWidth, imgHeight);
    y += 55;

    doc.setFontSize(12);
    doc.text('Quotation', doc.internal.pageSize.width / 2, y, {
      align: 'center',
    });
    y += 40;

    doc.setFontSize(12);
    let currentY = y;

    const leftFields = [
      { label: 'Bill To', value: '' },
      { label: '', value: `${record?.customer?.customer_name}` || 'N/A' },
      {
        label: '',
        value:
          `${record?.customer?.office_address?.shop}, ${record?.customer?.office_address?.area}` ||
          'N/A',
      },
      {
        label: '',
        value:
          `${record?.customer?.office_address?.landmark}, ${record?.customer?.office_address?.area}` ||
          'N/A',
      },
      {
        label: '',
        value:
          `${record?.customer?.office_address?.city}, ${record?.customer?.office_address?.state} - ${record?.customer?.office_address?.pin_code}` ||
          'N/A',
      },
      { label: '', value: '' },
      { label: '', value: '' },
      { label: '', value: '' },
      { label: 'Ship To (if Different)', value: '' },
      {
        label: '',
        value:
          `${record?.customer?.factory_address?.shop}, ${record?.customer?.factory_address?.area}` ||
          'N/A',
      },
      {
        label: '',
        value:
          `${record?.customer?.factory_address?.landmark}, ${record?.customer?.factory_address?.area}` ||
          'N/A',
      },
      {
        label: '',
        value:
          `${record?.customer?.factory_address?.city}, ${record?.customer?.factory_address?.state} - ${record?.customer?.factory_address?.pin_code}` ||
          'N/A',
      },
    ];

    const rightFields = [
      {
        label: 'Date: ',
        value: dayjs(record?.quotation_date).format('DD-MM-YYYY'),
      },
      { label: 'Quotation No: ', value: record?.quotation_no || 'N/A' },
      { label: '', value: '' },
      { label: '', value: '' },
      { label: '', value: '' },
      { label: '', value: '' },
      { label: 'Kind Attention', value: '' },
      {
        label:
          record?.customer?.contact_persons[0]?.contact_person_name || 'N/A',
        value: '',
      },
      {
        label:
          `+${record?.customer?.contact_persons[0]?.contact_person_mobile_number}` ||
          'N/A',
        value: '',
      },
    ];

    const lineHeight = 15;

    const leftFieldsX = 8;
    const rightFieldsX = doc.internal.pageSize.width / 2 + 50;

    let leftFieldsY = y;

    leftFields.forEach(term => {
      const isSectionHeader =
        term.label.trim() === 'Bill To' ||
        term.label.trim() === 'Ship To (if Different)';

      if (isSectionHeader) {
        doc.setFillColor(2, 96, 187); // Blue background
        doc.setTextColor(255, 255, 255); // White text
        doc.rect(leftFieldsX - 2, leftFieldsY - 12, 120, lineHeight, 'F'); // 'F' = fill only
        doc.setFont('WorkSans', 'bold');
        doc.text(term.label, leftFieldsX, leftFieldsY);
        doc.setFont('WorkSans', 'normal');
        doc.setTextColor(0, 0, 0);
      } else if (term.label.trim()) {
        doc.setFont('WorkSans', 'bold');
        doc.text(term.label, leftFieldsX, leftFieldsY);
        doc.setFont('WorkSans', 'normal');
        doc.text(term.value, leftFieldsX + 90, leftFieldsY);
      } else {
        doc.setFont('WorkSans', 'normal');
        doc.text(term.value, leftFieldsX, leftFieldsY);
      }

      leftFieldsY += 15;
    });

    currentY = y;
    const rightColX = doc.internal.pageSize.width / 2 + 150;

    rightFields.forEach(field => {
      if (field.label === 'Kind Attention') {
        doc.setFont('WorkSans', 'bold');
        doc.setFillColor(2, 96, 187); // Black background
        doc.setTextColor(255, 255, 255);
        doc.rect(570, currentY - 12, 200, 17, 'F'); // Adjust width/height as needed
      } else {
        doc.setFont('WorkSans', 'normal');
        doc.setTextColor(0, 0, 0);
      }
      doc.text(field.label, rightColX, currentY);
      doc.text(field.value, rightColX + 90, currentY);
      currentY += lineHeight;
    });

    y = currentY + 70;
    const imageMap = {};
    const isImageUrl = url => {
      return /\.(jpeg|jpg|png|gif|bmp)$/i.test(url);
    };
    const getFileExtension = url => {
      return url.split('.').pop() || '';
    };
    if (record?.quotation_details) {
      const imageLoadPromises = record?.quotation_details
        .filter(
          item =>
            item?.die_profile?.die_diagram &&
            isImageUrl(item.die_profile.die_diagram),
        )
        .map(async item => {
          try {
            const base64 = await loadImageAsBase64(
              item.die_profile.die_diagram,
            );
            imageMap[item.id] = {
              base64,
              extension: getFileExtension(
                item.die_profile.die_diagram,
              ).toLowerCase(),
            };
            return { success: true, id: item.id };
          } catch (error) {
            console.error(`Failed to load image for item ${item.id}:`, error);
            return { success: false, id: item.id };
          }
        });

      await Promise.all(imageLoadPromises);
    }
    const pdfColumns = ['Sr. No.'];
    const mappedColumns = [(item, index) => index + 1];

    checkedList.forEach(col => {
      switch (col) {
        case 'die_profile':
          pdfColumns.push('Profile Number');
          mappedColumns.push(item => item.die_profile?.die_number || 'N/A');

          pdfColumns.push('Profile Image');
          mappedColumns.push(item => {
            if (item.die_profile?.die_diagram) {
              return imageMap[item.id] ? 'Image' : 'N/A';
            }
            return 'N/A';
          });

          pdfColumns.push('Profile Description');
          mappedColumns.push(item => {
            const profile = item.die_profile;

            if (!profile) return 'N/A';

            return (
              [
                profile.dimension1 &&
                `${Number(profile.dimension1).toFixed(2)} MM`,
                profile.dimension2 &&
                `${Number(profile.dimension2).toFixed(2)} MM`,
                profile.dimension3 &&
                `${Number(profile.dimension3).toFixed(2)} MM`,
                profile.dimension4 &&
                `${Number(profile.dimension4).toFixed(2)} MM`,
              ]
                .filter(Boolean)
                .join(' X ') || 'N/A'
            );
          });
          break;
        case 'weight_range':
          pdfColumns.push('Weight Range/Piece(kg)');
          mappedColumns.push(item => item.weight_range || 'N/A');
          break;
        case 'length':
          pdfColumns.push('Length(mm)');
          mappedColumns.push(item => item.length || 'N/A');
          break;
        case 'pieces':
          pdfColumns.push('Pieces');
          mappedColumns.push(item => item.pieces || 'N/A');
          break;
        case 'net_weight':
          pdfColumns.push('Net Weight(kg)');
          mappedColumns.push(item =>
            item.net_weight ? Number(item.net_weight).toFixed(3) : '0.000',
          );
          break;
        case 'packed_weight':
          pdfColumns.push('Packed Weight(kg)');
          mappedColumns.push(item =>
            item.packed_weight
              ? Number(item.packed_weight).toFixed(3)
              : '0.000',
          );
          break;
        case 'dispatched_weight':
          pdfColumns.push('Dispatched Weight(kg)');
          mappedColumns.push(item =>
            item.dispatched_weight
              ? Number(item.dispatched_weight).toFixed(3)
              : '0.000',
          );
          break;
        case 'pending_weight':
          pdfColumns.push('Pending Weight(kg)');
          mappedColumns.push(item =>
            item.pending_weight
              ? Number(item.pending_weight).toFixed(3)
              : '0.000',
          );
          break;
        case 'alloy':
        case 'alloy_temp':
          pdfColumns.push('Alloy/Temp');
          mappedColumns.push(item => {
            const alloy = item.alloy?.name
              ? `${item.alloy.name}${item.alloy.color_code ? ` (${item.alloy.color_code})` : ''}`
              : 'N/A';
            const temper = item.temper?.name
              ? `${item.temper.name}${item.temper.code ? ` (${item.temper.code})` : ''}`
              : 'N/A';
            return `${alloy} / ${temper}`;
          });
          break;
        case 'surface_finish':
          pdfColumns.push('Finish');
          mappedColumns.push(item => item.surface_finish || 'N/A');
          break;
        case 'price_per_kg':
          pdfColumns.push('Price/Kg(Rs.)');
          mappedColumns.push(item => item.price_per_kg || 'N/A');
          break;
        case 'conversion':
          pdfColumns.push('Conversion');
          mappedColumns.push(item => item.conversion || 'N/A');
          break;
        case 'finishing_price':
          pdfColumns.push('Finishing Rate');
          mappedColumns.push(item => item.finishing_price || 'N/A');
          break;
      }
    });
    const bodyRows = record?.quotation_details.map((item, index) => {
      return [
        index + 1, // SR NO.
        item.die_profile?.die_number || '',
        imageMap[item.id] ? 'Image' : 'N/A',
        `${item.die_profile?.dimension1 || ''} MM` +
        (item.die_profile?.dimension2
          ? ` X ${item.die_profile?.dimension2} MM`
          : '') +
        (item.die_profile?.dimension3
          ? ` X ${item.die_profile?.dimension3} MM`
          : ''),
        item.length,
        item.pieces,
        Number(item.net_weight).toFixed(3),

        `${item.alloy?.name || ''} ${item.temper?.code || ''}`,
        item.surface_finish || '',

        Number(item.price_per_kg).toFixed(2),
        '0.00',

        Number(item.total_basic_amount).toFixed(2),
        Number(item.gst_rate).toFixed(2),
        Number(item.total_amount).toFixed(2),
      ];
    });
    const totalAmount = record?.quotation_details.reduce(
      (sum, d) => sum + parseFloat(d.total_amount || 0),
      0,
    );
    const tableResult = doc.autoTable({
      head: [
        [
          { content: 'SR NO.', rowSpan: 2 },
          { content: 'PROFILE NO.', rowSpan: 2 },
          { content: 'IMAGE', rowSpan: 2 },
          { content: 'DESCRIPTION', rowSpan: 2 },
          { content: 'LENGTH (mm)', rowSpan: 2 },
          { content: 'QUANTITY', colSpan: 2 }, // changed from 3 to 2
          { content: 'ALLOY/TEMP-GRADE', rowSpan: 2 },
          { content: 'FINISH', rowSpan: 2 },
          { content: 'PRICE / KGS (Rs.)', colSpan: 2 },
          { content: 'TOTAL BASIC AMOUNT(Rs.)', rowSpan: 2 },
          { content: 'GST(Rs.)', colSpan: 1 },
          { content: 'TOTAL(Rs.)', rowSpan: 2 },
        ],
        [
          { content: 'PIECES' },
          { content: 'WEIGHT (kg.)' },
          { content: 'Item Rate' },
          { content: 'Other' },
          { content: 'IGST(18%)' },
        ],
      ],
      body: bodyRows,
      columnStyles: {
        2: { cellWidth: 80, minCellHeight: 65, minCellWidth: 45 }, // 2 is the index of "IMAGE" column, set width to 30 units
      },
      startY: y,
      theme: 'grid',
      pageBreak: 'auto',
      tableWidth: 'auto',
      styles: {
        fontSize: 10,
        fontStyle: 'normal',
        cellPadding: { top: 10, bottom: 10, left: 10, right: 10 },
        lineWidth: 0.9,
        valign: 'middle',
        halign: 'center',
        overflow: 'linebreak',
      },
      headStyles: {
        fillColor: [2, 96, 187],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        halign: 'center',
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      didDrawCell: function (data) {
        const dieDiagramColumnIndex = pdfColumns.indexOf('Profile Image');
        if (
          data.column.index === 2 &&
          data.cell.section === 'body' &&
          data.cell.raw === 'Image' &&
          data.row.index < record.quotation_details.length
        ) {
          const item = record.quotation_details[data.row.index];
          if (!item || !imageMap[item.id]) return;

          const padding = 3;
          doc.setFillColor(255, 255, 255);
          doc.rect(
            data.cell.x + padding,
            data.cell.y + padding,
            data.cell.width - 2 * padding,
            data.cell.height - 2 * padding,
            'F',
          );
          const MAX_WIDTH = data.cell.width - 6; // 3px padding on each side
          const MAX_HEIGHT = data.cell.height - 6; // 3px padding on each side

          try {
            const imgX = data.cell.x + 3;
            const imgY = data.cell.y + 3;

            doc.addImage(
              imageMap[item.id].base64,
              'PNG',
              imgX,
              imgY,
              MAX_WIDTH,
              MAX_HEIGHT,
              undefined,
              'FAST',
            );
          } catch (error) {
            console.error('Error adding image to PDF:', error);
            doc.text(
              'Image Error',
              data.cell.x + data.cell.width / 2,
              data.cell.y + data.cell.height / 2,
              {
                align: 'center',
              },
            );
          }
        }
      },
      didParseCell: function (data) {
        if (
          data.cell.raw !== null &&
          !isNaN(data.cell.raw) &&
          data.cell.raw !== ''
        ) {
          data.cell.styles.halign = 'right';
        }
        if (data.section === 'body') {
          data.cell.styles.textColor = [0, 0, 0];
          data.cell.styles.fontStyle = 'normal';
        }
      },
      margin: { left: 10, right: 10 },
      didDrawPage: data => {
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFontSize(8);
        doc.text(
          `Page ${data.pageNumber} of ${pageCount}`,
          doc.internal.pageSize.width - 80,
          doc.internal.pageSize.height - 10,
        );
      },
    });
    const lastTable = tableResult.lastAutoTable;
    const columnStyles = {};

    lastTable.columns.forEach((col, i) => {
      columnStyles[i] = { cellWidth: parseFloat(col.width.toFixed(2)) };
    });
    let finalY = tableResult.lastAutoTable.finalY;
    const tableResult2 = doc.autoTable({
      body: [
        [
          {
            content: 'Total :',
            colSpan: 5,
            styles: { halign: 'center', fontStyle: 'bold' },
          }, // Skip first 5 columns
          {
            content: `${record?.total_pieces} Nos.`,
            styles: { fontStyle: 'bold' },
          },
          {
            content: `${record?.total_net_weight.toFixed(2)} Kg.`,
            styles: { fontStyle: 'bold' },
          },
          { content: '', colSpan: 4 }, // Fill the rest of the row
          {
            content: `${record?.total_basic_amount}`,
            colSpan: 1,
            styles: { fontStyle: 'bold' },
          },
          {
            content: `${record?.total_gst_amount}`,
            colSpan: 1,
            styles: { fontStyle: 'bold' },
          },
          {
            content: `${record?.total_amount}`,
            colSpan: 1,
            styles: { fontStyle: 'bold' },
          },
        ],
      ],
      columnStyles: columnStyles,
      theme: 'grid',
      styles: {
        fontSize: 10,
        cellPadding: 2,
        overflow: 'linebreak',
      },
      margin: { left: 10, right: 10 },
      tableWidth: 'auto',
      startY: finalY,
    });
    let finalYYt = tableResult2.lastAutoTable.finalY;
    const tableResult3 = doc.autoTable({
      body: [
        [
          {
            content: 'Total Payable Amount:',
            styles: { halign: 'right', fontStyle: 'bold' },
          },
          {
            content: totalAmount.toFixed(2),
            styles: { halign: 'right', fontStyle: 'bold' },
          },
        ],
      ],
      theme: 'grid', // No outer border
      styles: {
        fontSize: 10,
        cellPadding: 2,
      },
      margin: { left: 10, right: 10 },
      tableWidth: 'auto',
      startY: finalYYt,
    });
    let finalYY = tableResult3.lastAutoTable.finalY;
    const remainingSpace = doc.internal.pageSize.height - finalYY;
    if (remainingSpace < 200) {
      // Less space? Add new page
      doc.addPage();
      finalYY = 20;
    }
    doc.setFontSize(12);
    doc.setFont('WorkSans', 'bold');

    doc.setFillColor(2, 96, 187); // Black background
    doc.rect(530, finalYY + 12, 200, 17, 'F'); // Adjust width/height as needed
    doc.setTextColor(255, 255, 255); // White text
    doc.text('Bank Details', 530, finalYY + 22);
    y = finalYY + 40;

    doc.setTextColor(0, 0, 0);
    const terms = [];

    const bank_details = [
      { label: 'GST No:', value: `${record?.customer?.gstin_number || 'N/A'}` },
      {
        label: 'Bank Name:',
        value: `${record?.customer?.banking_details[0]?.bank_name || 'N/A'}`,
      },
      {
        label: 'Branch:',
        value: `${record?.customer?.banking_details[0]?.bank_branch_address || 'N/A'}`,
      },
      {
        label: 'A/C No:',
        value: `${record?.customer?.banking_details[0]?.bank_account_number || 'N/A'}`,
      },
      {
        label: 'IFSC Code:',
        value: `${record?.customer?.banking_details[0]?.bank_ifsc_code || 'N/A'}`,
      },
    ];

    doc.setFontSize(10);

    const termsX = 8;
    const bankX = doc.internal.pageSize.width / 2 + 110;

    let termsY = y;
    let bankY = y;

    terms.forEach(term => {
      if (term.label.trim()) {
        doc.setFont('WorkSans', 'bold');
        doc.text(term.label, termsX, termsY);
        doc.setFont('WorkSans', 'normal');
        if (term.label === 'Duties Taxes & Govt. Levies:') {
          doc.text(term.value, termsX + 150, termsY);
        } else {
          doc.text(term.value, termsX + 90, termsY);
        }
      } else {
        doc.text(term.value, termsX, termsY);
      }
      termsY += 15;
    });

    bank_details.forEach(field => {
      doc.setFont('WorkSans', 'bold');
      doc.text(field.label, bankX, bankY);
      doc.setFont('WorkSans', 'normal');
      doc.text(field.value, bankX + 80, bankY);
      bankY += 15;
    });
    y += 220;
    const spaceNeededForFooter = 20; // Adjust depending on your footer height
    const lastY = Math.max(termsY, bankY);

    if (lastY + spaceNeededForFooter > pageHeight) {
      doc.addPage();
      y = 40; // Reset y for new page
    } else {
      y = lastY + 20; // Some spacing before footer
    }
    let lastTermsConsitionPositon = 0;
    if (record?.terms_and_condition) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = record.terms_and_condition;

      let termsY = y;
      doc.setFontSize(14);
      doc.setFont('WorkSans', 'bold');
      doc.text(
        'Terms and Conditions',
        doc.internal.pageSize.width / 2,
        termsY,
        {
          align: 'center',
        },
      );
      termsY += 30;
      const processNode = (node, level = 0, indent = 0) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (!text) return termsY;
        }

        const textMargin = 10 + indent;
        const maxWidth = doc.internal.pageSize.width - textMargin * 2;
        if (termsY > doc.internal.pageSize.height - 40) {
          doc.addPage();
          termsY = 40;
          lastTermsConsitionPositon = termsY;
        }
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (text) {
            doc.setFont('WorkSans', 'normal');
            doc.setFontSize(9);
            const lines = doc.splitTextToSize(
              text,
              doc.internal.pageSize.width - 80,
            );
            doc.text(lines, textMargin, termsY);
            termsY += lines.length * 10 + 5;
            lastTermsConsitionPositon = termsY;
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          switch (node.tagName.toLowerCase()) {
            case 'h3':
              doc.setFont('WorkSans', 'bold');
              doc.setFontSize(11);
              const titleText = node.textContent.trim();
              doc.text(titleText, textMargin, termsY);
              termsY += 15;
              lastTermsConsitionPositon = termsY;
              break;

            case 'p':
              if (node.textContent.trim()) {
                doc.setFont('WorkSans', 'normal');
                doc.setFontSize(9);
                const paragraphText = node.textContent.trim();
                const lines = doc.splitTextToSize(
                  paragraphText,
                  doc.internal.pageSize.width - 80,
                );
                doc.text(lines, textMargin, termsY);
                termsY += lines.length * 10 + 10;
                lastTermsConsitionPositon = termsY;
              }
              break;

            case 'ul':
              termsY += 5;
              for (const child of node.children) {
                if (child.tagName.toLowerCase() === 'li') {
                  const bulletPoint = '• ';
                  doc.setFont('WorkSans', 'normal');
                  doc.setFontSize(9);

                  const bulletWidth =
                    (doc.getStringUnitWidth(bulletPoint) *
                      doc.internal.getFontSize()) /
                    doc.internal.scaleFactor;
                  doc.text(bulletPoint, textMargin, termsY);

                  const itemText = child.textContent.trim();
                  const itemLines = doc.splitTextToSize(
                    itemText,
                    doc.internal.pageSize.width - 90 - bulletWidth,
                  );
                  doc.text(itemLines, textMargin + bulletWidth, termsY);
                  termsY += itemLines.length * 10 + 5;
                  if (termsY > doc.internal.pageSize.height - 40) {
                    doc.addPage();
                    termsY = 40;
                    lastTermsConsitionPositon = termsY;
                  }
                }
              }
              termsY += 5;
              break;

            default:
              for (const child of node.childNodes) {
                processNode(child, level + 1, indent);
              }
          }
        }

        return termsY;
      };
      for (const child of tempDiv.childNodes) {
        processNode(child);
      }
    }

    doc.setFontSize(10);
    doc.setFont('WorkSans', 'bold');
    doc.text('Prepared By', 90, lastTermsConsitionPositon + 40, {
      align: 'right',
    });

    doc.text(
      'Authorised Signatory',
      doc.internal.pageSize.width - 200,
      lastTermsConsitionPositon + 40,
      { align: 'left' },
    );
    doc.text(
      '(Alux ERP)',
      doc.internal.pageSize.width - 220,
      lastTermsConsitionPositon + 50,
      { align: 'left' },
    );
    y += 20;

    /* Last Footer Row */
    const latPageHeight = doc.internal.pageSize.height;
    const footerY = latPageHeight - 20;

    const footerAddress = '110, Ganesh glory, Godrej garden City road, jagatpur Ahmedabad - 382481';
    const footerContact = 'info@aluxerp.com | www.aluxerp.com';

    const pageWidth = doc.internal.pageSize.width;
    const footerY2 = footerY + 9;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text(footerAddress, pageWidth / 2, footerY, { align: 'center' });

    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text(footerContact, pageWidth / 2, footerY2, { align: 'center' });

    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.line(20, footerY - 10, pageWidth - 20, footerY - 10);
    const pdfBlob = doc.output('blob');
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = URL.createObjectURL(pdfBlob);
    document.body.appendChild(iframe);

    iframe.onload = () => {
      iframe.contentWindow.print();
    };
  };

  const dynamicColumns = columns.filter(column =>
    checkedList.includes(column.dataIndex || column.key),
  );
  const handleColumnVisibilityChange = checkedValues => {
    setCheckedList(checkedValues);
  };

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={checkedValues => {
            handleColumnVisibilityChange(checkedValues);
          }}
        >
          <Row gutter={16}>
            <Col xs={12} md={12}>
              <Checkbox value="SrNo" disabled>
                Sr.No.
              </Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="quotation_date">Quotation Date</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="quotation_no">Quotation No</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="customer">Customer</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="workorder_no">WorkOrder No</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="converted_date">Converted Date</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="status">Status</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_at">Created At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="created_by__first_name">Created By</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_at">Updated At</Checkbox>
            </Col>
            <Col xs={24} md={12}>
              <Checkbox value="updated_by__first_name">Updated By</Checkbox>
            </Col>
            <Col xs={12} md={12}>
              <Checkbox value="action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const csvheaders = [
    { label: 'Sr. No', key: 'SrNo' },
    { label: 'Quotation Date', key: 'quotation_date' },
    { label: 'Quotation No', key: 'quotation_no' },
    { label: 'Customer', key: 'customer' },
    { label: 'WorkOrder No', key: 'workorder_no' },
    { label: 'Converted Date', key: 'converted_date' },
    { label: 'Status', key: 'status' },
    { label: 'Created At', key: 'created_at' },
    { label: 'Created By', key: 'created_by__first_name' },
    { label: 'Updated At', key: 'updated_at' },
    { label: 'Updated By', key: 'updated_by__first_name' },
  ];

  const csvFilterheaders = csvheaders.filter(column =>
    checkedList.includes(column.key),
  );

  const csvData = data.map((item, index) => ({
    SrNo: index + 1,
    quotation_date: item?.quotation_date,
    quotation_no: item?.quotation_no,
    customer: item?.customer?.customer_name,
    workorder_no: item?.workorder_no ? item?.workorder_no : 'Not Converted to Workorder',
    converted_date: item?.converted_date ? item?.converted_date : 'N/A',
    status: item?.status,
    created_at: item?.created_at
      ? moment(item?.created_at).format('DD-MM-YYYY')
      : 'N/A',
    created_by__first_name: item?.created_by__first_name
      ? `${item?.created_by__first_name} ${item?.created_by__last_name}`
      : 'N/A',
    updated_at: item?.updated_at
      ? moment(item?.updated_at).format('DD-MM-YYYY')
      : 'N/A',
    updated_by__first_name: item?.updated_by__first_name
      ? `${item?.updated_by__first_name} ${item?.updated_by__last_name}`
      : 'N/A',
  }));

  const activityLog = async () => {
    dispatch(
      createActivityLog({
        action: 'DOWNLOAD',
        module_name: 'Quotation',
        ip_address: ipAddress,
        discription: 'Quotation excel download successfully!',
      }),
    );
  };

  return (
    <div className="mainwrap">
      <div className="sticyaction">
        <Row
          className="pagenamerow mb-0"
          justify="space-between"
          align="middle"
        >
          <Col>
            <h2>Quotations</h2>
            <div className="bredcrumbwrp">
              <Link
                className="back"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/dashboard">Home</Link> },
                  { title: 'Quotations' },
                ]}
              />
            </div>
          </Col>
          <Col>
            <Space size="small">
              <Input
                placeholder="Search"
                className="searchbox"
                prefix={<SearchOutlined />}
                value={inputValue}
                style={{ width: 190 }}
                onChange={handleSearch}
              />
              <Link>
                <Tooltip title="Filter">
                  <Button
                    type="primary"
                    disabled={!search && !orderBy}
                    className="iconlink"
                    onClick={resetFilter}
                  >
                    <FilterIcon />
                  </Button>
                </Tooltip>
              </Link>
              {currentUser.permissions.permissions.quotation.includes(
                'download_quotation_excel_copy',
              ) && (
                  <Tooltip
                    placement="top"
                    title={'Export Excel'}
                    onClick={activityLog}
                  >
                    <Button
                      type="primary"
                      className="iconlink"
                      style={{ width: '10px' }}
                    >
                      <CSVLink
                        filename={'Quotations.csv'}
                        className="iconlink"
                        style={{ width: '10px' }}
                        data={csvData}
                        headers={csvFilterheaders}
                      >
                        <FileExcelOutlined />
                      </CSVLink>
                    </Button>
                  </Tooltip>
                )}
              {currentUser.permissions.permissions.quotation.includes(
                'print_quotation_pdf_copy',
              ) && (
                  <Tooltip placement="top" title={'Print'}>
                    <Button
                      type="primary"
                      className="iconlink"
                      onClick={handlePrint}
                    >
                      <PrintIcons />
                    </Button>
                  </Tooltip>
                )}
              <Tooltip title="Add Quotation">
                {currentUser.permissions.permissions.quotation.includes(
                  'add_quotation',
                ) && (
                    <Link to="/create-quotation">
                      <Button type="primary" icon={<PlusOutlined />}>
                        Add Quotation
                      </Button>
                    </Link>
                  )}
              </Tooltip>
              {currentUser.permissions.permissions.quotation.includes(
                'delete_quotation',
              ) && (
                  <Link to="/archive-quotation-list" className="iconlink">
                    <Tooltip title="Archive">
                      <Archiveicon />
                    </Tooltip>
                  </Link>
                )}
              <div className="gridiconswrap">
                <Tooltip placement="topLeft" title="Column Filter Options">
                  <Dropdown
                    overlay={columnMenu}
                    trigger={['click']}
                    placement="bottomRight"
                    visible={dropdownVisible}
                    onVisibleChange={setDropdownVisible}
                  >
                    <Button
                      type="primary"
                      icon={<ColumnList />}
                      onClick={e => e.preventDefault()}
                    />
                  </Dropdown>
                </Tooltip>
              </div>
            </Space>
          </Col>
        </Row>
        {/* <div
          className="actionrowbtn"
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '5px',
            gap: '15px',
          }}
        >
          {currentUser.permissions.permissions.nalco.includes(
            'view_nalcomaster',
          ) && (
              <Link to="/nalco">
                <Button
                  type="primary"
                  size="small"
                  icon={<Undergroup />}
                  className="lightorange"
                >
                  Nalco Rate
                </Button>
              </Link>
            )}
        </div> */}
      </div>

      <div className="tablewrp">
        <Table
          rowKey="id"
          // rowSelection={rowSelection}
          columns={dynamicColumns}
          dataSource={data}
          pagination={false} // Disable built-in pagination
          loading={status === 'loading'}
          scroll={{ x: '600px' }}
          onChange={handleTableChange}
        />
      </div>

      <Pagination
        current={page}
        pageSize={pagesize}
        total={totalRecord}
        showSizeChanger
        onShowSizeChange={handlePageSizeChange}
        pageSizeOptions={['20', '50', '100']}
        showTotal={total => `Total ${total} items`}
        onChange={handlePageChange}
        locale={{ items_per_page: 'Items / Page' }}
      />
    </div>
  );
}
